import React from 'react';
import { Link } from 'react-router-dom';
import styles from './HomePage.module.css';
import { useAuth } from '../context/AuthContext';
import { useLives } from '../context/LivesContext';
import UserHeader from '../components/UserHeader';
import Quest, { QuestData } from '../components/Quest';
import { useQuest } from '../hooks/useQuest';
import { formatTime } from '../utils/questUtils';
import { QUEST_DATA, COLORS } from '../constants';

const HomePage: React.FC = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const { addLives } = useLives();
  const eatingOutQuest = useQuest();
  const savingsQuest = useQuest();

  const handleCompleteSavings = () => {
    savingsQuest.resetQuest();
    addLives(3); // Add 3 lives for completing the savings quest
  };

  const quests: QuestData[] = [
    {
      ...QUEST_DATA.EATING_OUT,
      isStarted: eatingOutQuest.isStarted,
      timeRemaining: eatingOutQuest.timeRemaining,
      progressPercentage: eatingOutQuest.progressPercentage,
      showTimer: true,
      actionButtonText: 'Give Up',
      actionButtonColor: COLORS.DANGER,
      onStart: eatingOutQuest.startQuest,
      onAction: eatingOutQuest.resetQuest
    },
    {
      ...QUEST_DATA.SAVINGS,
      isStarted: savingsQuest.isStarted,
      timeRemaining: savingsQuest.timeRemaining,
      progressPercentage: savingsQuest.progressPercentage,
      showTimer: false,
      actionButtonText: 'Complete',
      actionButtonColor: COLORS.SUCCESS,
      onStart: savingsQuest.startQuest,
      onAction: handleCompleteSavings
    }
  ];

  return (
    <div className={styles.homePage}>
      <h1>Welcome to WealthPlay</h1>
      <UserHeader user={user} />
      
      <div className={styles.navigation}>
        <Link to="/transactions" className={styles.navLink}>
          Transactions
        </Link>
        <Link to="/games" className={styles.navLink}>
          Games
        </Link>
        {!isAuthenticated && (
          <>
            <Link to="/login" className={styles.navLink}>
              Login
            </Link>
            <Link to="/register" className={styles.navLink}>
              Register
            </Link>
          </>
        )}
      </div>

      {/* Quests Section */}
      <section className={styles.questsSection}>
        <h2 className={styles.questsTitle}>Quests</h2>
        {quests.map((quest) => (
          <Quest 
            key={quest.id} 
            quest={quest} 
            formatTime={formatTime}
          />
        ))}
      </section>

      {/* Logout button at bottom */}
      {isAuthenticated && (
        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <button onClick={logout} style={{ padding: '0.5rem 1rem' }}>Logout</button>
        </div>
      )}
    </div>
  );
};

export default HomePage; 